import{gql as e}from"@apollo/client";const t=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $answers: [QuestionAnswerMatchAnswerInputType]
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerMatch: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          answers: $answers
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
        ... on QuestionAnswerMatchType {
          answers {
            definedPosition
            questionAnswerMatchId
            questionResponseMatchId
            summaryFeedback {
              ... on SummaryFeedbackRankAndNoteType {
                id
                note
                rank
              }
            }
          }
        }
        id
      }
    }
  }
`;export{t as SET_USER_ANSWER_MATCH_MUTATION};
//# sourceMappingURL=useSetUserAnswerMatch.graphql.js.map
